// components/PitchDeck/04_HowItWorks.jsx
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function HowItWorks() {
    return (
        <div className="min-h-screen flex items-center bg-gray-50 py-20">
            <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
                <h2 className="text-4xl md:text-6xl font-bold text-gray-900 text-center mb-16">
                    How It Works
                </h2>
                <div className="grid md:grid-cols-4 gap-8 text-center">
                    <div>
                        <div className="text-6xl mb-6">1</div>
                        <p className="text-2xl font-semibold mb-4">Everyday Inputs</p>
                        <p className="text-lg text-gray-700">Simple sales, receipts, payments — even manual notes.</p>
                    </div>
                    <div>
                        <div className="text-6xl mb-6">2</div>
                        <p className="text-2xl font-semibold mb-4">AI Mapping</p>
                        <p className="text-lg text-gray-700">Intelligent automation turns them into accurate ledgers & trails.</p>
                    </div>
                    <div>
                        <div className="text-6xl mb-6">3</div>
                        <p className="text-2xl font-semibold mb-4">Compliance Built-In</p>
                        <p className="text-lg text-gray-700">Auto-track VAT/withholding → direct FIRS submission.</p>
                    </div>
                    <div>
                        <div className="text-6xl mb-6">4</div>
                        <p className="text-2xl font-semibold mb-4">Insights Delivered</p>
                        <p className="text-lg text-gray-700">Real-time dashboard + natural-language AI queries.</p>
                    </div>
                </div>
                <div className="mt-16 text-center">
                    <p className="text-3xl font-bold text-[#4285F4]">
                        Result: Owners get professional accounting without hiring one.
                    </p>
                    <p className="text-xl mt-6 text-gray-700">
                        First customer: Acquired via auditor recommendation — processing ₦15M daily sales.
                    </p>
                </div>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-700/40 rounded-full text-gray-700 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="/pitch/market-opportunity">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}